import * as R from 'ramda';
import { useState, useCallback } from 'react';
// helpers
import * as G from '../helpers';
//////////////////////////////////////////////////

const useToggleStatus = (initialValue = false) => {
  const [status, setStatus] = useState(initialValue);

  const handleToggleStatus = useCallback((event) => {
    G.stopPropagation(event);

    setStatus((currentStatus) => R.not(currentStatus));
  }, []);

  return [status, handleToggleStatus];
};

export default useToggleStatus;
